<template>
<div class=" white-background pa-5 rounded ma-1">
    <div v-for="activity in $page.activities" class="flow-activity clickable hoverable ma-1">
        <SpeechBubble :activity="activity" />  
    </div>
</div>
</template>

<script>
// import DataHelpers from '../helpers/DataHelpers'
import SpeechBubble from './ui/SpeechBubble'

export default {
    data() {
        return {
        
        }
    },

    inject: ['$page'],

    components: {
        SpeechBubble
    },
    
    props: {
        activities: Array,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        function1() {

        },
    },

    created() {

    }
}
</script>

<style scoped>
.flow-activity {
    font-size: .9em;
}
</style>




// WEBPACK FOOTER //
// FlowActivity.vue?2cbbd253